const PIXEL_ID = '2110222259389669';

type Pixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  loaded: boolean;
  version: string;
  push: Pixel;
  disablePushState: boolean;
  allowDuplicatePageViews: boolean;
};

let ownedPixel: Pixel | undefined;
let sdkReady: Promise<void> | undefined;
const sentIds = new Set<string>();

/** Astro shortcodes have no GTM; keep this SDK scoped to their eligible PageView. */
export async function sendCampaignMetaPageView(eventId: string, isEligible: () => boolean): Promise<void> {
  const browser = window as Window & { fbq?: Pixel; _fbq?: Pixel };
  if (
    window.location.hostname !== 'skin-seoul.com' ||
    !/^\/(?:campaign(?:\/[a-z0-9]+(?:-[a-z0-9]+)*)?\/?$|blog(?:\/|$))/.test(window.location.pathname) ||
    !isEligible() ||
    sentIds.has(eventId) ||
    (browser.fbq && browser.fbq !== ownedPixel) ||
    (browser._fbq && browser._fbq !== ownedPixel)
  ) {
    return;
  }

  if (!sdkReady) {
    const pixel = ((...args: unknown[]) => {
      if (pixel.callMethod) {
        pixel.callMethod(...args);
      } else {
        pixel.queue.push(args);
      }
    }) as Pixel;
    pixel.queue = [];
    pixel.push = pixel;
    pixel.loaded = true;
    pixel.version = '2.0';
    pixel.disablePushState = true;
    pixel.allowDuplicatePageViews = true;
    ownedPixel = browser.fbq = pixel;
    browser._fbq ??= pixel;
    pixel('set', 'autoConfig', false, PIXEL_ID);
    pixel('init', PIXEL_ID);
    sdkReady = new Promise<void>((resolve, reject) => {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      script.onload = () => resolve();
      script.onerror = () => {
        script.remove();
        sdkReady = undefined;
        if (browser.fbq === pixel) {
          delete browser.fbq;
        }
        if (browser._fbq === pixel) {
          delete browser._fbq;
        }
        if (ownedPixel === pixel) {
          ownedPixel = undefined;
        }
        reject(new Error('Meta SDK unavailable'));
      };
      document.head.appendChild(script);
    });
  }

  try {
    await sdkReady;
    if (!isEligible() || sentIds.has(eventId) || browser.fbq !== ownedPixel || browser._fbq !== ownedPixel) {
      return;
    }
    sentIds.add(eventId);
    ownedPixel?.('trackSingle', PIXEL_ID, 'PageView', {}, { eventID: eventId });
  } catch {
    // Optional browser delivery must not interrupt the existing EA event.
  }
}
